"use client"

import { AlertCircle } from "lucide-react"
import Link from "next/link"
import { useEffect } from "react"

interface ObrigadoErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function ObrigadoError({ error, reset }: ObrigadoErrorProps) {
  useEffect(() => {
    // Log error to error reporting service
    console.error("Thank you page error:", error)
  }, [error])

  return (
    <main className='flex min-h-[70vh] flex-col items-center justify-center px-6 py-12'>
      <div className='mx-auto w-full max-w-md space-y-6 text-center'>
        <div className='flex justify-center'>
          <div className='flex size-16 items-center justify-center rounded-full bg-red-50'>
            <AlertCircle aria-hidden='true' className='size-8 text-red-600' />
          </div>
        </div>

        <div className='space-y-2'>
          <h1 className='font-semibold text-2xl text-foreground tracking-tight'>
            Erro ao carregar pedido
          </h1>
          <p className='text-muted-foreground text-sm'>
            {error.message ||
              "Ocorreu um erro ao carregar os detalhes do seu pedido. Por favor, tente novamente."}
          </p>
        </div>

        <div className='flex flex-col gap-3 sm:flex-row sm:justify-center'>
          <button
            className='inline-flex h-11 items-center justify-center rounded-lg bg-primary px-6 font-medium text-primary-foreground text-sm transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
            onClick={reset}
            type='button'
          >
            Tentar novamente
          </button>

          <Link
            className='inline-flex h-11 items-center justify-center rounded-lg border border-input bg-background px-6 font-medium text-sm transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
            href='/conta/pedidos'
          >
            Ver meus pedidos
          </Link>
        </div>

        <Link
          className='inline-block text-muted-foreground text-sm underline-offset-4 hover:underline'
          href='/'
        >
          Voltar para a página inicial
        </Link>
      </div>
    </main>
  )
}
